import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BAND_ACTIONS, ITravelBlockPassenger } from "Bands/types";
import { copy } from "shared/assets";
import { IAPIState, IStatus } from "shared/types";
import {
  dataMetaSelector,
  deleteTravelBlockPassenger,
  dispatchGetTravelBlockPassengers,
} from "Bands/state";
import { addTemporaryToast } from "shared/components/Toast";
import { DeleteModal } from "shared/components";
import { useClearActionMetaOnUnMount } from "Bands/utils";

const deleteCopy = copy.travelBlock.passenger.delete;

interface Props {
  blockId: string;
  passenger: ITravelBlockPassenger;
  handleClose: () => void;
}

export const DeleteTravelBlockPassengerModal: React.FC<Props> = ({
  blockId,
  passenger,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteTravelBlockPassenger));

  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteTravelBlockPassenger);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatchGetTravelBlockPassengers({
        dispatch,
        blockId,
      });

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteCopy.messages.success,
        })
      );

      handleClose();
    }
  }, [apiMeta?.status, blockId, dispatch, handleClose]);

  const handleDelete = () => {
    dispatch(deleteTravelBlockPassenger(passenger.id));
  };

  return (
    <DeleteModal
      name={passenger.user.firstname || ""}
      type="passenger"
      handleDelete={handleDelete}
      handleClose={handleClose}
      apiMeta={apiMeta}
    />
  );
};
